export const overridePaymasterDataMiddleware = async (struct, { overrides }) => {
    struct.paymasterAndData =
        overrides?.paymasterAndData != null ? overrides?.paymasterAndData : "0x";
    return struct;
};
//# sourceMappingURL=overridePaymasterData.js.map